import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const ScrollToTop: React.FC = () => {
  const { key } = useLocation();

  useLayoutEffect(() => {
    // Reset immediately
    window.scrollTo(0, 0);

    // Keep overriding scroll for a short period to fight macOS inertia/momentum scroll
    let frames = 0;
    const lock = () => {
      window.scrollTo(0, 0);
      frames++;
      if (frames < 10) {
        requestAnimationFrame(lock);
      }
    };
    requestAnimationFrame(lock);
  }, [key]);

  return null;
};

export default ScrollToTop;
